import type { ReactNode } from "react";

import { useSheetDrag } from "../lib/useSheetDrag";

interface Props {
  title: string;
  hint?: string;
  onClose: () => void;
  children: ReactNode;
}

/** Шторка снизу: меню упражнения, таймер отдыха, RPE, сводка тренировки. */
export default function Sheet({ title, hint, onClose, children }: Props) {
  const body = useSheetDrag(onClose);
  return (
    <div className="sheet" role="dialog" aria-label={title}>
      <div className="sheet__backdrop" onClick={onClose} />
      <div className="sheet__body" ref={body}>
        <div className="sheet__grip" />
        <p className="sheet__title">{title}</p>
        {hint && <p className="sheet__hint">{hint}</p>}
        {children}
      </div>
    </div>
  );
}
